"use client";

import type { FeatureCollection } from "geojson";
import { RMapContextProvider } from "maplibre-react-components";
import React, { type ReactElement } from "react";
import { WeatherPanelLegend, WeatherMap } from "@/components";

interface WeatherMainProps {
  features: FeatureCollection;
}

function WeatherMain({ features }: Readonly<WeatherMainProps>): ReactElement {
  return (
    <div className="relative flex-1 w-full min-h-[calc(100svh-var(--globalnav-height))] h-full bg-accent">
      <RMapContextProvider>
        <WeatherPanelLegend counter={features.features.length} />
        <WeatherMap features={features} />
      </RMapContextProvider>
    </div>
  );
}

export { WeatherMain, type WeatherMainProps };
